<script setup lang="ts">
import Header from '@/components/Header/Header.vue'
import Footer from '@/components/shared/Footer.vue'

</script>
<template>
    <div class="relative min-h-dvh overflow-hidden bg-[#444]">
        <Header :dark="true" />
        <div class="text-white">
            <slot />
        </div>
        <div class="pointer-events-none absolute inset-0 z-0 min-h-full w-full bg-[#040404]/80 backdrop-blur-[250px]"></div>
    </div>
    <Footer :dark="true" />

</template>
